export default {
  dynamics: '{{change}} Vor-{{time_unit}}',
};
